'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { TopicSuggestion } from '@/types/searchSuggestions';
import { HighlightedSuggestion } from '@/components/Header/HighlightedSuggestion';
import { SuggestionLinkItem } from '@/components/Header/SuggestionLinkItem';
import { getMPListPageHrefArgs, getShowroomHrefArgs } from '@/utility/urls';
type TopicSuggestionItemProps = {
  topic: TopicSuggestion;
  /** Navigates to the topic's results — also resets the search field. */
  onNavigate: () => void;
  /** Renders the group heading above the first topic of the group. */
  showGroupLabel?: boolean;
  /** Separates the last topic from the group below. */
  showDivider?: boolean;
};

/**
 * A design-theme topic the query named. Its own component rather than a variant of
 * `TagSuggestionItem`: the destination is either a category-filtered or a plain search for the topic
 * name, and the category hint is optional.
 */
export const TopicSuggestionItem = t0 => {
  const $ = _c(25);
  const {
    topic,
    onNavigate,
    showGroupLabel,
    showDivider
  } = t0;
  const t = useTranslations("header");
  let t1;
  if ($[0] !== showGroupLabel || $[1] !== t) {
    t1 = showGroupLabel ? t("topicSuggestionsLabel") : undefined;
    $[0] = showGroupLabel;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const groupLabel = t1;
  let t2;
  if ($[3] !== topic.category?.slugs || $[4] !== topic.licenseShowroomSlug || $[5] !== topic.searchTerm) {
    t2 = topic.licenseShowroomSlug ? getShowroomHrefArgs({
      userSlug: topic.licenseShowroomSlug
    }) : getMPListPageHrefArgs({
      categorySlugs: topic.category?.slugs,
      searchTerm: topic.searchTerm
    });
    $[3] = topic.category?.slugs;
    $[4] = topic.licenseShowroomSlug;
    $[5] = topic.searchTerm;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = `Searchbar - Topic - ${topic.name}`;
  let t4;
  if ($[7] !== groupLabel) {
    t4 = groupLabel && <span className="sr-only">{groupLabel}: </span>;
    $[7] = groupLabel;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== topic.highlighted) {
    t5 = <HighlightedSuggestion>{topic.highlighted}</HighlightedSuggestion>;
    $[9] = topic.highlighted;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <span className="min-w-24 truncate">{t4}{t5}</span>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t || $[15] !== topic.category) {
    t7 = topic.category && <span className="ml-auto min-w-0 truncate pl-2 text-sm text-neutral-700">{t("suggestionInCategory", {
        category: topic.category.name
      })}</span>;
    $[14] = t;
    $[15] = topic.category;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== groupLabel || $[18] !== onNavigate || $[19] !== showDivider || $[20] !== t2 || $[21] !== t3 || $[22] !== t6 || $[23] !== t7) {
    t8 = <SuggestionLinkItem href={t2} groupLabel={groupLabel} showDivider={showDivider} onNavigate={onNavigate} dataTracking={t3}>{t6}{t7}</SuggestionLinkItem>;
    $[17] = groupLabel;
    $[18] = onNavigate;
    $[19] = showDivider;
    $[20] = t2;
    $[21] = t3;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
};